export function canShowApplyNew(applications = []) {
  if (!applications || applications.length === 0) return true; // no apps → allow

  // const latestApp = applications.reduce((latest, app) => {
  //   if (!latest) return app;
  //   const latestDate = new Date(latest.approval_date);
  //   const currentDate = new Date(app.approval_date);
  //   return currentDate > latestDate ? app : latest;
  // }, null);

  // if (!latestApp?.approval_date) return false; // if no approval_date, allow apply

  // const approvalDate = new Date(latestApp.approval_date);
  // const sixMonthsAgo = new Date();
  // sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);

  // return approvalDate < sixMonthsAgo;

  return false;
}
